/**
 * WI 58: shared email validation mirroring the backend RegistrationValidation.IsValidEmail
 * (non-empty, a local part, an '@', and a dotted domain that does not end in a dot).
 */
export function isValidEmail(email: string | null | undefined): boolean {
  if (!email) {
    return false;
  }
  const trimmed = email.trim();
  if (trimmed.length === 0) {
    return false;
  }
  const atIndex = trimmed.indexOf('@');
  if (atIndex <= 0) {
    return false;
  }
  const afterAt = trimmed.substring(atIndex + 1);
  const dotIndex = afterAt.indexOf('.');
  if (dotIndex < 1) {
    return false;
  }
  if (afterAt.endsWith('.')) {
    return false;
  }
  return true;
}
